import React from 'react';

/**
 * Chip / quick-add pill atom.
 */
export default function Chip({ children, onClick, className = '', active = false }) {
  return (
    <button
      type="button"
      className={`ca-chip ${active ? 'ca-chip--active' : ''} ${className}`.trim()}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
